import { render, staticRenderFns } from "./itemImage.vue?vue&type=template&id=19bc15ee&scoped=true&lang=html&"
import script from "./itemImage.vue?vue&type=script&lang=js&"
export * from "./itemImage.vue?vue&type=script&lang=js&"
import style0 from "./itemImage.vue?vue&type=style&index=0&id=19bc15ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bc15ee",
  null
  
)

export default component.exports